<template>
<div role="group" class="b-form-group form-group">
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('DATE')">
        <inputvalidation :formerror="formError" name="name">
          <timepicker v-model="formData.date" lang="en" type="date" format="YYYY-MM-DD"></timepicker>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('START')">
        <inputvalidation :formerror="formError" name="name">
          <timepicker v-model="formData.startTimeOut" lang="en" type="time" format="hh:mm A" :time-picker-options="{ start: '00:00', step: '00:15', end: '23:30' }"></timepicker>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
  <div class="form-row mb-lg">
    <div class="col-sm-12">
      <b-form-fieldset v-bind:label="$t('END')">
        <inputvalidation :formerror="formError" name="name">
          <timepicker v-model="formData.closeTimeOut" lang="en" type="time" format="hh:mm A" :time-picker-options="{ start: '00:00', step: '00:15', end: '23:45' }"></timepicker>
        </inputvalidation>
      </b-form-fieldset>
    </div>
  </div>
</div>
</template>

<script>
export default
{
  name: 'DateExceptionsForm',
  props: ['formData', 'formError'],
  data: function()
  {
    return {

    }
  },
  created()
  {
    var me = this;
  },
  methods:
  {

  },
  computed:
  {

  }
}
</script>
